import { Dropdown as PixieDropdown } from "@pacificoseguros/pixie/react/dropdown";
import React from "react";
import { UseFormMethods } from "react-hook-form";
import { FlexLayout } from "../../../components/layout/flex-layout";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { omit } from "../../../libs/utils/object";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
type SelectFieldProps = DropdownNS.DropdownProps & {
    fieldDefinition: FieldDefinition;
    rhForm: UseFormMethods<any>;
};

export const SelectField: React.FC<SelectFieldProps> = (
    props: SelectFieldProps
) => {
    const pixieDropdownOptions = omit(props, ["fieldDefinition", "rhForm"]);
    const currentvalue = props.rhForm.watch(props.fieldDefinition.key);
    return (
        <FlexLayout direction="column">
            <label
                htmlFor={props.fieldDefinition.key}
                style={{ color: "var(--secondary)" }}
            >
                <b>{props.fieldDefinition.label || <>&nbsp;</>}</b>
            </label>
            <SpacingBox mb={4} />
            <PixieDropdown
                {...pixieDropdownOptions}
                id={props.fieldDefinition.key}
                name={props.fieldDefinition.key}
                value={currentvalue}
                onChange={(event: any) => {
                    const target: any = event.target || event.currentTarget;
                    props.rhForm.setValue(
                        props.fieldDefinition.key,
                        target.value,
                        { shouldValidate: true }
                    );
                }}
                onBlur={() => {
                    props.rhForm.setValue(
                        props.fieldDefinition.key,
                        props.rhForm.getValues(props.fieldDefinition.key),
                        { shouldValidate: true }
                    );
                }}
            />
        </FlexLayout>
    );
};
